import React from 'react';
import { Tabs } from 'antd';
import { SdgComparisonTab } from './SdgComparisonTab';
import { SdgCsvUpload } from './SdgCsvUpload';
import SdgReviewTab from './SdgReviewTab';

const { TabPane } = Tabs;

const SdgTabGroup = () => {
  return (
    <Tabs defaultActiveKey="1">
      <TabPane tab="CSV Upload (ZIP)" key="1">
        <SdgCsvUpload />
      </TabPane>
      <TabPane tab="Comparison" key="2">
        <SdgComparisonTab />
      </TabPane>
      <TabPane tab="Indicator Mapping" key="3">
        <SdgReviewTab />
      </TabPane>
      <TabPane tab="Country Mapping" key="4">
        <SdgReviewTab mappingType="country" />
      </TabPane>
    </Tabs>
  );
};

export default SdgTabGroup;
